import { render, staticRenderFns } from "./EmailNotificationList.vue?vue&type=template&id=6753d5c8&scoped=true&"
import script from "./EmailNotificationList.vue?vue&type=script&lang=js&"
export * from "./EmailNotificationList.vue?vue&type=script&lang=js&"
import style0 from "./EmailNotificationList.vue?vue&type=style&index=0&id=6753d5c8&lang=scss&scoped=true&"
import style1 from "./EmailNotificationList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6753d5c8",
  null
  
)

export default component.exports